import { GridCellProps } from '@progress/kendo-react-grid';
import { MouseEvent, useCallback, useContext } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';
import useRedirect from 'src/hooks/useRedirect';
import GridCellBase from './GridCellBase';

const GoToPoDetails = (props: GridCellProps) => {
  const { getUrl, redirect } = useRedirect();
  const [cellClick] = useContext(EditCellContext);
  const { openNewTab = true } = cellClick?.(null) || {};
  const field = props.field || '';
  const value = props.dataItem[field];

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      redirect(getUrl('poDetails')(props.dataItem.poId), true, openNewTab);
    },
    [getUrl, openNewTab, props.dataItem.poId, redirect]
  );

  return (
    <GridCellBase {...props} title={value} rowSelectionEnabled={false}>
      <button onClick={handleClick} className="text-link cursor-pointer underline">
        {value}
      </button>
    </GridCellBase>
  );
};

export default GoToPoDetails;